@if (visions.length > 0) {
    <adapt-button-toggle-group adaptToolbarContent
                               alignment="center"
                               [(value)]="currentTab"
                               (valueChange)="onTabChanged($event)">
        <button [adaptToggleGroupButton]="DisplayViewType.IntegratedView"
                adaptButtonIcon="fal fa-fw fa-braille">Integrated
        </button>
        <button [adaptToggleGroupButton]="DisplayViewType.PersonView"
                adaptButtonIcon="fal fa-fw fa-people">Person
        </button>
        <button [adaptToggleGroupButton]="DisplayViewType.CategoryView"
                adaptButtonIcon="fal fa-fw fa-layer-group">Category
        </button>
    </adapt-button-toggle-group>

    @switch (currentTab) {
        @case (DisplayViewType.IntegratedView) {
            @if (hasAnyCompletedIntegratedVision) {
                <adapt-category-vision-accordion [teamId]="teamId"
                                                 [expandAll]="true"
                                                 [integratedOnly]="true"
                                                 [indicateIncompleteCategories]="true"
                                                 [showExpandCollapseMenu]="true"></adapt-category-vision-accordion>
            } @else {
                <adapt-call-to-action>
                    <adapt-call-to-action-title>Integrated Vision</adapt-call-to-action-title>
                    <p>The integrated vision combines the aspirations of all business owners into a unified vision for the business. This
                        helps ensure that everyone is aligned and working towards the same long-term goals.</p>
                    <p>No integrated vision has been recorded yet.</p>
                    @if (canEditTeamVision) {
                        @if (hasAnyCompletedPersonalVision) {
                            <ng-container>
                                <!-- Need this ng-container to get rid of extendedDiagnostics.checks.controlFlowPreventingContentProjection error
                                    caused by adaptCallToActionButton -->
                                <p>Capture one now to align everyone on the long-term direction.</p>
                                <button adaptCallToActionButton
                                        adaptButtonIcon="add"
                                        [adaptBlockingClick]="captureIntegratedVision">
                                    Integrate vision
                                </button>
                                <button adaptCallToActionButton
                                        adaptButtonIcon="fal fa-fw fa-layer-plus"
                                        [adaptBlockingClick]="assignIntegratedVision">
                                    Assign integrated vision
                                </button>
                            </ng-container>
                        } @else {
                            <div class="alert alert-info">
                                <b>Note:</b> An integrated vision should only be recorded after at least one personal vision has been
                                completed.
                            </div>
                        }
                    }
                </adapt-call-to-action>
            }
        }
        @case (DisplayViewType.PersonView) {
            <adapt-display-visions-by-person [teamId]="teamId"></adapt-display-visions-by-person>
        }
        @case (DisplayViewType.CategoryView) {
            <adapt-category-vision-accordion [teamId]="teamId"
                                             [expandAll]="true"
                                             [showExpandCollapseMenu]="true"></adapt-category-vision-accordion>
        }
        @default {
            <div class="alert alert-danger">Unexpected switch case</div>
        }
    }
} @else {
    @if (canEditTeamVision) {
        <div adaptToolbarContent>
            <button adaptButtonIcon="add"
                    data-test="capture-vision-button"
                    [adaptBlockingClick]="captureVision">
                Capture vision
            </button>
        </div>
    }

    <adapt-call-to-action>
        <adapt-call-to-action-title>Vision</adapt-call-to-action-title>
        <p>An owner's vision represents the long-term aspirations and future state that the business owner(s) want to achieve</p>
        Important considerations:
        <ul>
            <li>If there are multiple owners, their visions need to be aligned</li>
            <li>Vision should be realistic but ambitious</li>
            <li>Should align with personal aspirations</li>
            <li>Typically looks 5-10 years into the future</li>
        </ul>
        @if (canEditTeamVision) {
            <button adaptCallToActionButton
                    adaptButtonIcon="add"
                    [adaptBlockingClick]="captureVision">
                Capture vision
            </button>
        }
    </adapt-call-to-action>
}
